<template>
  <div>
    <b-modal
      @shown="focusInput"
      ref="modal"
      :title="title"
      header-class="border-bottom-0"
      size="xl"
      no-close-on-backdrop
    >
      <div class="container-fluid">
        <!-- form  -->
        <div class="row">
          <div class="col-md-3">
            <h5 class="text-primary">
              <i class="fas fa-address-card" /> Dados da pessoa
            </h5>
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Tipo:">
              <b-form-radio-group
                v-model="form.person_type.value"
                :options="form.person_type.options"
                name="radios-btn-primary"
                style="cursor: pointer"
              ></b-form-radio-group>
            </b-form-group>
          </div>
          <div class="col-md-8">
            <b-form-group label="Esta pessoa é?" :state="false">
              <b-form-checkbox
                inline
                style="margin-right: 10px"
                v-model="form.is_client.value"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer">
                  <i class="text-primary fas fa-user-friends" /> Cliente
                </span>
              </b-form-checkbox>
              <b-form-checkbox
                inline
                style="margin-right: 10px"
                v-model="form.is_vendor.value"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer">
                  <i class="text-primary fas fa-industry" friends /> Fornecedor
                </span>
              </b-form-checkbox>
              <b-form-checkbox
                inline
                style="margin-right: 10px"
                v-model="form.is_shipping_company.value"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer">
                  <i class="text-primary fas fa-shipping-fast" friends />
                  Transportadora
                </span>
              </b-form-checkbox>
              <b-form-checkbox
                inline
                style="margin-right: 10px"
                v-model="form.is_salesman.value"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer">
                  <i class="text-primary fas fa-user-tie" friends /> Vendedor
                </span>
              </b-form-checkbox>
              <div
                class="invalid-feedback-overwrite text-danger"
                v-if="entityTypeIsNull"
              >
                Selecione pelo menos uma opção.
              </div>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <text-input
              ref="nameInput"
              v-model="form.name.value"
              :form="form"
              :name="'name'"
              :alias="form.name.alias"
            />
          </div>
          <div class="col-md-3">
            <text-input v-model="form.alias.value" :alias="form.alias.alias" />
          </div>
          <!-- <div class="col-md-3">
            <text-input v-model="form.person_code.value" :alias="form.person_code.alias" />
          </div> -->
          <div class="col-md-3">
            <template v-if="!form.id.value">
              <number-input
                v-model="form.person_code.value"
                decimalPlaces="0"
                :defaultValueOverride="null"
                :emptyInputBehavior="'null'"
                :alias="form.person_code.alias"
                :disabled="isPersoncodeDisable"
              />
              <b-form-checkbox
                inline
                style="margin-right: 10px"
                v-model="form.auto_person_code.value"
                :value="1"
                :unchecked-value="0"
              >
                <small style="cursor: pointer">{{
                  autoPersoncodeIdText
                }}</small>
              </b-form-checkbox>
            </template>
            <template v-else>
              <number-input
                v-model="form.person_code.value"
                decimalPlaces="0"
                :defaultValueOverride="null"
                :emptyInputBehavior="'null'"
                :alias="form.person_code.alias"
              />
            </template>
          </div>
        </div>

        <div class="row" v-show="isPessoaFisica">
          <div class="col">
            <mask-input
              v-model="form.cpf.value"
              :mask="'cpf'"
              :alias="form.cpf.alias"
            />
          </div>

          <div class="col">
            <text-input v-model="form.rg.value" :alias="form.rg.alias" />
          </div>
          <div class="col">
            <text-input
              v-model="form.inscricao_pr.value"
              :alias="form.inscricao_pr.alias"
            />
          </div>
          <div class="col d-flex align-items-end">
            <div class="form-group">
              <label for="inscricao_estadual_isento">Indicador da IE </label>
              <b-form-select
                id="inscricao_estadual_isento"
                size="sm"
                v-model="form.inscricao_estadual_isento.value"
                :options="indIEDestOptions"
              />
            </div>
          </div>
        </div>

        <div class="row" v-show="isPessoaFisica">
          <div class="col-md-2">
            <date-input
              v-model="form.date_birth.value"
              :alias="form.date_birth.alias"
            />
          </div>

          <div class="col-6 col-md-6">
            <text-input
              v-model="form.mother_name.value"
              :alias="form.mother_name.alias"
            />
          </div>
        </div>

        <div class="row" v-show="!isPessoaFisica">
          <div class="col-md-3">
            <mask-input
              v-model="form.cnpj.value"
              :mask="'cnpj'"
              :alias="form.cnpj.alias"
            />
          </div>

          <div class="col-md-3">
            <text-input
              v-model="form.inscricao_estadual.value"
              :alias="form.inscricao_estadual.alias"
              :disabled="isInscricaoEstadualIsento"
            />
          </div>
          <div
            class="col-md-3 d-flex align-items-end"
            style="padding-left: 0px"
          >
            <div class="form-group">
              <label for="inscricao_estadual_isento">Indicador da IE </label>
              <b-form-select
                id="inscricao_estadual_isento"
                size="sm"
                v-model="form.inscricao_estadual_isento.value"
                :options="indIEDestOptions"
              />
            </div>
          </div>
          <div class="col-md-3">
            <text-input
              v-model="form.inscricao_municipal.value"
              :alias="form.inscricao_municipal.alias"
            />
          </div>
        </div>

        <br />
        <br />

        <div class="row">
          <div class="col-md-3">
            <h5 class="text-primary">
              <i class="fas fa-map-marked-alt" /> Endereço
            </h5>
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col-8 col-md-6">
            <text-input
              v-model="form.address.value"
              :alias="form.address.alias"
            />
          </div>
          <div class="col-4 col-md-2">
            <text-input
              v-model="form.number.value"
              :alias="form.number.alias"
            />
          </div>
          <div class="col-md-4">
            <text-input
              v-model="form.complement.value"
              :alias="form.complement.alias"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-8 col-md-4">
            <text-input
              v-model="form.district.value"
              :alias="form.district.alias"
            />
          </div>
          <div class="col-4 col-md-2">
            <mask-input
              v-model="form.zipcode.value"
              :mask="'cep'"
              :alias="form.zipcode.alias"
            />
          </div>
          <!--<div class=" col-md-4">
            <search-select-input
              :alias="'Cidade'"
              :url="'api/city/selectAll'"
              :valueProperty="'id'"
              :displayedValueProperty="'city'"
              :displayedValue="form.city.value"
              v-model="form.city_id.value">
            </search-select-input>
          </div>
          <div class=" col-md-2">
            <text-input
              v-model="form.city_id.value"
              :alias="'state'"
            />
          </div>-->
          <div class="col-md-4">
            <search-input
              :alias="form.city_id.alias"
              v-model="form.city_id.value"
              :displayedValue="form.city.value"
              :form="form"
              :name="'city_id'"
              @search="searchCity($event)"
              :searchResult="searchCityResults"
              :isLoading="searchCityLoading"
              @selected="setCity($event)"
            >
              <search-input-option
                v-for="(row, index) in searchCityResults.data"
                :key="index"
                :index="index"
                @click="setCity(row)"
              >
                <div>
                  {{ row.city }} - {{ row.state }}
                  <br />
                </div>
              </search-input-option>
            </search-input>
          </div>

          <div class="col-md-2">
            <text-input
              v-model="form.state.value"
              :alias="form.state.alias"
              :disabled="true"
            />
          </div>
        </div>

        <br />
        <br />

        <div class="row">
          <div class="col-md-3">
            <h5 class="text-primary"><i class="fas fa-phone-alt" /> Contato</h5>
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col-6 col-md-3">
            <mask-input
              v-model="form.phone_wa.value"
              :mask="'phone'"
              :alias="form.phone_wa.alias"
            />
          </div>

          <div class="col-6 col-md-3">
            <mask-input
              v-model="form.phone2.value"
              :mask="'phone'"
              :alias="form.phone2.alias"
            />
          </div>
          <div class="col-6 col-md-3">
            <mask-input
              v-model="form.phone3.value"
              :mask="'phone'"
              :alias="form.phone3.alias"
            />
          </div>
          <div class="col-6 col-md-3">
            <mask-input
              v-model="form.phone4.value"
              :mask="'phone'"
              :alias="form.phone4.alias"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <text-input
              v-model="form.email1.value"
              :alias="form.email1.alias"
            />
          </div>
          <div class="col-md-4">
            <text-input
              v-model="form.email2.value"
              :alias="form.email2.alias"
            />
          </div>
          <div class="col-md-4">
            <text-input
              v-model="form.website.value"
              :alias="form.website.alias"
            />
          </div>
        </div>

        <br />
        <br />
        <div class="row">
          <div class="col-md-3">
            <h5 class="text-primary">
              <i class="fas fa-credit-card" /> Crédito
            </h5>
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <b-form-checkbox
                switch
                v-model="form.can_buy_in_payment_method_5.value"
                :value="1"
                :unchecked-value="0"
              >
                <template v-if="form.can_buy_in_payment_method_5.value == 1">
                  <span style="cursor: pointer"
                    >Pode comprar no crediário.</span
                  >
                </template>
                <template
                  v-else-if="form.can_buy_in_payment_method_5.value == 0"
                >
                  <span style="cursor: pointer"
                    >Bloqueado para compras no crediário</span
                  >
                </template>
              </b-form-checkbox>
              <b-form-checkbox
                inline
                switch
                style="margin-right: 10px"
                v-model="form.use_debt_limit.value"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer">Informar limite de crédito.</span>
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <template v-if="form.use_debt_limit.value == 1">
              <number-input
                v-model="form.debt_limit_value.value"
                :alias="form.debt_limit_value.alias"
              />
            </template>
          </div>
        </div>

        <br />
        <br />
        <div class="row">
          <div class="col-md-3">
            <h5 class="text-primary">
              <i class="fas fa-info-circle" /> Outras Informações
            </h5>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
             <salesman-search
              v-model="form.salesman_id.value"
              :name="form.salesman.value.name"
            />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <textarea
                maxlength="500"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="5"
                v-model="form.notes.value"
              ></textarea>
            </div>
          </div>
          <!-- Cliente Ativo-->
          <div class="col-md-6" style="padding-bottom: 0px">
            <div class="form-group">
              <b-form-checkbox
                class="mb-2"
                switch
                v-model="form.status.value"
                :value="1"
                :unchecked-value="0"
              >
                <template v-if="form.status.value == 1">
                  <span style="cursor: pointer">Cadastro Ativo</span>
                </template>
                <template v-else-if="form.status.value == 0">
                  <span style="cursor: pointer">Cadastro Inativo</span>
                </template>
              </b-form-checkbox>

              <!-- <b-form-checkbox
                switch
                v-model="form.can_buy_in_payment_method_5.value"
                :value="1"
                :unchecked-value="0"
              >
                <template v-if="form.can_buy_in_payment_method_5.value == 1">
                  <span style="cursor:pointer">Pode comprar no crediário.</span>
                </template>
                <template v-else-if="form.can_buy_in_payment_method_5.value == 0">
                  <span style="cursor:pointer">Bloqueado para compras no crediário</span>
                </template>
              </b-form-checkbox>-->
            </div>
          </div>
          <!-- Cliente Ativo-->
        </div>
      </div>

      <br />

      <error-handler :error="error" />

      <b-alert
        :show="alertData.isVisible"
        fade
        variant="danger"
        @dismissed="alertData.isVisible = false"
        dismissible
        >{{ alertData.message }}</b-alert
      >

      <!-- form  -->

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="store"
        >
          <i class="fas fa-check"></i> Salvar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import Form from "./../../mixins/Form.js";

import SalesmanSearch from "@/components/SalesmanSearch";

export default {
  components: {
    Avatar,
    SalesmanSearch,
  },

  data: function () {
    return {
      indIEDestOptions: [
        { value: 1, text: "1 | Contribuinte ICMS" },
        {
          value: 2,
          text: "2 | Contribuinte isento de Inscrição no cadastro de Contribuintes",
        },
        {
          value: 9,
          text: "9 | Não Contribuinte, que pode ou não possuir Inscrição Estadual no Cadastro de Contribuintes do ICMS",
        },
      ],
      form: new Form({
        id: {},

        person_type: {
          default: "f",
          options: [
            { value: "f", text: "Pessoa Física" },
            { value: "j", text: "Pessoa Jurídica" },
          ],
          alias: "Tipo de pessoa:",
        },

        is_client: {
          alias: "is_client",
          default: 1,
        },

        is_vendor: {
          alias: "is_vendor",
          default: 0,
        },

        is_shipping_company: {
          default: 0,
        },

        is_salesman: {
          default: 0,
        },

        name: {
          alias: "Nome",
          validate: {
            required: true,
          },
        },

        alias: {
          alias: "Apelido",
        },

        person_code: {
          alias: "Código do Cliente",
        },

        auto_person_code: {
          default: 1,
        },
        salesman_id: {
          alias: "Vendedor",
        },
        salesman: {},

        date_birth: {
          alias: "Data de Nascimento",
        },

        cpf: {
          alias: "Cpf",
        },

        rg: {
          alias: "Identidade",
        },

        inscricao_pr: {
          alias: "Inscrição Produtor Rural",
        },

        mother_name: {
          alias: "Nome da Mãe",
        },

        cnpj: {
          alias: "Cnpj",
        },

        inscricao_estadual: {
          alias: "Inscrição Estadual",
        },

        inscricao_estadual_isento: {
          value: 0,
        },

        inscricao_municipal: {
          alias: "Inscrição Municipal",
        },

        phone_wa: {
          alias: "Whatsapp",
        },

        phone2: {
          alias: "Telefone",
        },

        phone2_is_whatsapp: {
          alias: "phone2_is_whatsapp",
        },

        phone3: {
          alias: "Telefone",
        },

        phone3_is_whatsapp: {
          alias: "phone3_is_whatsapp",
        },

        phone4: {
          alias: "Telefone",
        },

        phone4_is_whatsapp: {
          alias: "phone4_is_whatsapp",
        },

        email1: {
          alias: "Email",
        },

        email2: {
          alias: "Email",
        },

        website: {
          alias: "Site",
        },

        facebook: {
          alias: "facebook",
        },

        instagram: {
          alias: "instagram",
        },

        use_debt_limit: {
          default: 0,
        },

        debt_limit_value: {
          alias: "Limite de Crédito",
        },

        notes: {
          alias: "Observações",
        },

        status: {
          default: 1,
          alias: "status",
          validate: {
            required: true,
          },
        },

        can_buy_in_payment_method_5: {
          default: 1,
          alias: "Crediario",
          validate: {
            required: true,
          },
        },

        // address

        address: {
          alias: "Endereço",
        },

        number: {
          alias: "Número",
        },

        complement: {
          alias: "Complemento",
        },

        district: {
          alias: "Bairro",
        },

        zipcode: {
          alias: "Cep",
        },

        city_id: {
          alias: "Cidade",
        },

        city: {},

        state: {
          alias: "UF",
        },
      }),

      title: "Nova Pessoa",

      searchCityResults: {},

      searchCityLoading: false,

      error: null,

      alertData: {
        isVisible: false,
        message: null,
      },
    };
  },

  computed: {
    autoPersoncodeIdText() {
      if (!this.form.id.value) {
        return "Gerar Código automaticamente";
      } else {
        return "Alterar Código";
      }
    },

    auto_person_code() {
      return this.form.auto_person_code.value;
    },

    isPersoncodeDisable() {
      return this.form.auto_person_code.value == 1;
    },

    entityTypeIsNull() {
      return (
        this.form.is_client.value === 0 &&
        this.form.is_vendor.value === 0 &&
        this.form.is_salesman.value === 0
      );
    },

    isPessoaFisica() {
      return this.form.person_type.value == "f";
    },

    isInscricaoEstadualIsento() {
      return this.form.inscricao_estadual_isento.value != 1;
    },
  },

  watch: {
    auto_person_code(val) {
      if (val == 1) {
        this.form.person_code.value = "";
      }
    },

    isPessoaFisica: function (personType) {
      this.setPersonType(personType);
    },

    isInscricaoEstadualIsento: function (newValue) {
      if (newValue) {
        this.form.inscricao_estadual.value = null;
      }
    },
  },

  methods: {
    open(id = null) {
      this.resetForm();

      if (id) {
        this.title = "Atualizar pessoa";

        this.selectPerson(id);

        return;
      }
      this.title = "Nova pessoa";

      this.$refs.modal.show();
    },

    focusInput() {
      this.$refs.nameInput.setFocus();
    },

    setPersonType() {
      if (this.isPessoaFisica) {
        this.form.name.alias = "Nome";
        this.form.alias.alias = "Apelido";

        return;
      }

      this.form.name.alias = "Razão Social";
      this.form.alias.alias = "Nome Fantasia";
    },

    resetCpfOrCnpj(personType) {
      if (personType == "j") {
        this.form.cpf.value = null;
      } else {
        this.form.cnpj.value = null;
      }
    },

    selectPerson(id) {
      axios
        .post("api/person/edit/" + id)
        .then((response) => {
          this.form.setValues(response.data.person);

          this.$refs.modal.show();
        })
        .catch((error) => {
          this.error = error;
        });
    },

    store() {
      this.error = null;

      this.resetCpfOrCnpj(this.form.person_type.value);

      if (this.isFormValid()) {
        this.$store.commit("showLoading");

        var url = process.env.BASE_URL + "api/person/store";

        var message = "Uma nova pessoa foi adicionada.";

        if (this.form.id.value) {
          url = url + "/" + this.form.id.value;

          message =
            "O cadastro de " + this.form.name.value + " foi atualizado!";
        }

        axios
          .post(url, this.form.getValues())
          .then((response) => {
            this.$refs.modal.hide();

            this.$emit("stored");
            this.$store.commit({
              type: "showAlert",
              message: message,
              variant: "success",
            });
            this.$store.commit("hideLoading");

            return;
          })
          .catch((error) => {
            this.error = error;

            this.$store.commit("hideLoading");

            return;
          });
      }
    },

    isFormValid() {
      if (!this.form.isValid()) {
        this.alertData.message = this.form.getFirstErrorMsg();

        this.alertData.isVisible = true;

        return false;
      }

      if (this.entityTypeIsNull) {
        this.alertData.message =
          "Informe se esta pessoa é um cliente, fornecedor ou vendedor.";

        this.alertData.isVisible = true;

        return false;
      }

      return true;
    },

    resetForm() {
      this.error = null;

      this.alertData.isVisible = false;

      this.form.reset();
    },

    searchCity(search) {
      this.searchCityLoading = true;

      axios
        .post(`${process.env.BASE_URL}api/city/selectAll?page=${search.page}`, {
          city: search.text,
        })
        .then((response) => {
          this.searchCityResults = response.data;

          this.searchCityLoading = false;
        })
        .catch((error) => {
          this.error = error;
        });
    },

    setCity(city) {
      this.form.city_id.value = city.id;

      this.form.city.value = city.city;

      this.form.state.value = city.state;
    },
  },
};
</script>
